// wrap the root element with provider to use context
import React from "react"
import Provider from "./provider"
// import CacheBuster from "./CacheBuster";
import '@fortawesome/fontawesome-free/css/all.css';
export const wrapRootElement = Provider
// export const wrapRootElement = ({ element }) => (
//     <CacheBuster>
//         {({ loading, isLatestVersion, refreshCacheAndReload }) => {
//             if (loading) return null
//             if (!loading && !isLatestVersion) {
//                 // You can decide how and when you want to force reload
//                 refreshCacheAndReload()
//             }
//             return <Provider>{element}</Provider>
//         }}
//     </CacheBuster>
// )